import { Select } from 'antd'
import React, { ReactNode, useCallback, useEffect, useState } from 'react'
import AuthService from 'services/AuthService'
import { TOPICS } from 'utils'

export default function useTopic(initialTopic?: string): [string, () => ReactNode] {
    const [topics, setTopics] = useState(() => {
        let topics = AuthService.getTopicConfig().map(t => t.chatContext)
        return TOPICS.filter(t => {
            return topics.includes(t.topic)
        })
    })
    const [topic, setTopic] = useState<string>(initialTopic || topics[0]?.topic)

    useEffect(() => {
        if (initialTopic) {
            setTopic(initialTopic)
        }
    }, [initialTopic])


    let renderer: () => ReactNode = useCallback(
        () => {
            return <Select
                value={topic}
                style={{ width: 120 }}
                onChange={(value) => {
                    console.log(value)
                    setTopic(value)
                }}
                options={topics.map(t => ({ ...t, value: t.topic }))}
            />
        },
        [topic, setTopic],
    )

    return [topic, renderer]
}